import * as yup from 'yup';

import { useTranslations } from '../../../../../../../contexts/LocalizationContext';
import { QuickContactType } from '../../../../../model/enums/quick-contact-type.enum';

export const useAddQuickContactsFormValidation = (): yup.AnyObjectSchema => {
  const translations = useTranslations();

  return yup.object().shape({
    type: yup
      .string()
      .required()
      .oneOf([...Object.values(QuickContactType)]),
    nickname: yup.string().when(['type'], {
      is: (type: QuickContactType) => type === QuickContactType.USER,
      then: (schema) =>
        schema
          .required(translations('validation_required'))
          .max(191, translations('validation_too_long', { '{{maxLength}}': '191' })),
    }),
    street: yup.string().when(['type'], {
      is: (type: QuickContactType) => type === QuickContactType.USER,
      then: (schema) =>
        schema
          .required(translations('validation_required'))
          .max(100, translations('validation_too_long', { '{{maxLength}}': '100' })),
    }),
    streetNumber: yup.string().when(['type'], {
      is: (type: QuickContactType) => type === QuickContactType.USER,
      then: (schema) =>
        schema
          .required(translations('validation_required'))
          .max(20, translations('validation_too_long', { '{{maxLength}}': '20' })),
    }),
    postalCode: yup.string().when(['type'], {
      is: (type: QuickContactType) => type === QuickContactType.USER,
      then: (schema) =>
        schema
          .required(translations('validation_required'))
          .max(20, translations('validation_too_long', { '{{maxLength}}': '20' })),
    }),
    country: yup.mixed().when(['type'], {
      is: (type: QuickContactType) => type === QuickContactType.USER,
      then: (schema) => schema.test('country-required', translations('validation_required'), (val) => Boolean(val)),
    }),
    city: yup
      .mixed()
      .nullable()
      .when(['type'], {
        is: (type: QuickContactType) => type === QuickContactType.USER,
        then: (schema) => schema.test('city-required', translations('validation_required'), (val) => Boolean(val)),
      }),
    selectedRestaurants: yup.array().when(['type'], {
      is: (type: QuickContactType) => type === QuickContactType.RESTAURANT,
      then: (schema) =>
        schema.test('test restaurants', translations('validation_required'), (restaurants) => !!restaurants?.length),
    }),
  });
};
